const priorityUrls = [
  'https://www.parentool.cn/',
  'https://www.parentool.cn/about',
  'https://www.parentool.cn/privacy',
  'https://www.parentool.cn/app/toolmate/privacy',
  'https://www.parentool.cn/tool/pdf-compressor',
  'https://www.parentool.cn/tool/image-compressor',
  'https://www.parentool.cn/tool/pdf-rotate',
  'https://www.parentool.cn/tool/pdf-text-extractor'
]

const SearchIndexing = () => {
  return (
    <div className="bg-slate-50">
      <article className="mx-auto max-w-4xl px-4 py-10 md:py-14">
        <header className="border-b border-slate-200 pb-6">
          <h1 className="text-3xl font-bold text-slate-950">搜索引擎收录指引</h1>
          <p className="mt-3 max-w-3xl text-base leading-7 text-slate-600">
            这页用于整理 Parentool 在 Google 和百度上的收录流程，方便持续提交 sitemap、请求抓取和检查重点页面状态。
          </p>
        </header>

        <section className="mt-8">
          <h2 className="text-lg font-semibold text-slate-950">Google Search Console</h2>
          <div className="mt-3 space-y-2 text-sm leading-7 text-slate-600">
            <p>1. 验证站点属性 `https://www.parentool.cn`。</p>
            <p>2. 提交 `https://www.parentool.cn/sitemap.xml`。</p>
            <p>3. 使用 URL 检查工具优先请求抓取首页、隐私页和核心工具页。</p>
          </div>
        </section>

        <section className="mt-8">
          <h2 className="text-lg font-semibold text-slate-950">百度搜索资源平台</h2>
          <div className="mt-3 space-y-2 text-sm leading-7 text-slate-600">
            <p>1. 验证 `www.parentool.cn` 站点。</p>
            <p>2. 提交 `https://www.parentool.cn/sitemap.xml`。</p>
            <p>3. 使用普通收录或快速收录入口提交重点页面。</p>
            <p>4. 使用站点提供的百度推送接口批量推送核心 URL。</p>
          </div>
        </section>

        <section className="mt-8">
          <h2 className="text-lg font-semibold text-slate-950">优先提交页面</h2>
          <div className="mt-3 rounded-lg border border-slate-200 bg-white p-4">
            <ul className="space-y-2 text-sm text-slate-700">
              {priorityUrls.map(url => (
                <li key={url}>{url}</li>
              ))}
            </ul>
          </div>
        </section>
      </article>
    </div>
  )
}

export default SearchIndexing
